var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38317",
    "data-name": "Group 38317",
    transform: "translate(-311 -385.182)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7683",
    "data-name": "Rectangle 7683",
    width: 31,
    height: 31,
    rx: 5,
    transform: "translate(311 385.182)",
    fill: "#c7b9eb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "class-notes-svgrepo-com",
    transform: "translate(316.117 392.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38324",
    "data-name": "Group 38324",
    transform: "translate(3.883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38323",
    "data-name": "Group 38323",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_38319",
    "data-name": "Group 38319",
    transform: "translate(1.915 4.499)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65507",
    "data-name": "Path 65507",
    d: "M50.268,91.374H42.837a.372.372,0,0,1,0-.745h7.431a.372.372,0,1,1,0,.745Z",
    transform: "translate(-42.465 -90.629)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38320",
    "data-name": "Group 38320",
    transform: "translate(1.915 6.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65508",
    "data-name": "Path 65508",
    d: "M48.494,124.991H42.837a.372.372,0,1,1,0-.745h5.657a.372.372,0,1,1,0,.745Z",
    transform: "translate(-42.465 -124.246)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38321",
    "data-name": "Group 38321",
    transform: "translate(1.915 11.174)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65509",
    "data-name": "Path 65509",
    d: "M44.71,225.841H42.837a.372.372,0,0,1,0-.745H44.71a.372.372,0,1,1,0,.745Z",
    transform: "translate(-42.465 -225.096)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_38322",
    "data-name": "Group 38322",
    transform: "translate(1.915 12.843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_65510",
    "data-name": "Path 65510",
    d: "M43.9,259.458H42.837a.372.372,0,0,1,0-.745H43.9a.372.372,0,1,1,0,.745Z",
    transform: "translate(-42.465 -258.713)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_65511",
    "data-name": "Path 65511",
    d: "M20.241,1.727l-.849-.633a1,1,0,0,0-1.4.2h0L15.889,4.151V1.317a.372.372,0,0,0-.372-.372H13.974V.372a.372.372,0,0,0-.745,0V.945H12.116V.372a.372.372,0,1,0-.745,0V.945H10.258V.372a.372.372,0,0,0-.745,0V.945H8.4V.372a.372.372,0,1,0-.745,0V.945H6.543V.372a.372.372,0,1,0-.745,0V.945H4.255a.372.372,0,0,0-.372.372V16.772a.372.372,0,0,0,.372.372H15.517a.372.372,0,0,0,.372-.372V9.339l4.555-6.215h0A1,1,0,0,0,20.241,1.727ZM15.144,16.4H4.628V1.689H5.8v.572a.372.372,0,1,0,.745,0V1.689H7.656v.572a.372.372,0,1,0,.745,0V1.689H9.514v.572a.372.372,0,0,0,.745,0V1.689h1.113v.572a.372.372,0,0,0,.745,0V1.689h1.113v.572a.372.372,0,0,0,.745,0V1.689h1.171V5.172L13.2,7.837H6.171a.372.372,0,0,0,0,.745H12.66l-2.117,2.905h0a.37.37,0,0,0-.055.113l-.851,2.912H6.171a.372.372,0,0,0,0,.745H9.921a.371.371,0,0,0,.2-.059L12.9,13.4a.372.372,0,0,0,.1-.09l2.148-2.947V16.4Zm-4.092-4.078.994.741-1.493.965Zm1.567.24-1.256-.937,5.872-8.057,1.256.937Zm6.314-8.656-1.256-.937.4-.538,1.256.937Zm.915-1.227h0l-.069.092-1.256-.937.069-.092h0a.254.254,0,0,1,.355-.052l.849.633A.254.254,0,0,1,19.848,2.679Z",
    transform: "translate(-3.883)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/Note.c18cc2714808916ed257af47486b9d3a.svg";
export { ForwardRef as ReactComponent };